import { PaymentSetupComponent } from './../../component/payment-setup/payment-setup.component';
import { AgmCoreModule } from '@agm/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatChipsModule, MatFormFieldModule, MatIconModule, MatInputModule, MatMenuModule, MatSelectModule, MatTableModule, MatStepperModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { NgbDropdownModule, NgbModule, NgbRatingModule, NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { QRCodeModule } from 'angularx-qrcode';
import { DxButtonModule, DxChartModule, DxCheckBoxModule, DxDataGridModule, DxHtmlEditorModule, DxLoadPanelModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule } from 'devextreme-angular';
import { QuillModule } from 'ngx-quill';
import { CaptionPipe } from 'src/app/core/_base/layout/pipes/caption.pipe';
import { UpdateFinderPipe } from 'src/app/core/_base/layout/pipes/update-finder.pipe';
import { CoreModule } from '../../../core/core.module';
import { MenuSectionService } from '../../../provider/menu-section.service';
import { DeliveryComponent } from '../../component/delivery/delivery.component';
import { OrderTypesComponent } from '../../component/order-types/order-types.component';
import { PaymentTypesComponent } from '../../component/payment-types/payment-types.component';
import { PopupModule } from '../../component/popup/popup.module';
import { ProductPromotionComponent } from '../../component/product-promotion/product-promotion.component';
import { ReservationListComponent } from '../../component/reservation-list/reservation-list.component';
import { SharedModule } from '../../component/shared.module';
import { PartialsModule } from '../../partials/partials.module';
import { MarketingComponent } from '../activity/marketing/marketing.component';
import { EditProfileComponent } from '../activity/profiles/edit-profile/edit-profile.component';
import { ProfilesComponent } from '../activity/profiles/profiles.component';
import { RequestsComponent } from '../activity/requests/requests.component';
import { HomePage } from './home.page';
import { HotelInfoPage } from './hotel-info/hotel-info.page';
import { MenuItemPage } from './menu-item/menu-item.page';
import { MenuSectionPage } from './menu-section/menu-section.page';
import { CategoryFinderPipe } from './products/category-finder.pipe';
import { PriceFinderPipe } from './products/price-finder.pipe';
import { ProductsComponent } from './products/products.component';
import { WelcomePage } from './welcome/welcome.page';
import { RequestComponent } from '../activity/requests/request/request.component';
import { RedeemPopupComponent } from '../activity/requests/request/redeem-popup/redeem-popup.component';
import { LiveSupportComponent } from '../../component/live-support/live-support.component';



const routes: Routes = [
  { path: '', component: WelcomePage },
  {
    path: 'm', component: WelcomePage, children: [
      { path: 'menu-section/:id', component: MenuSectionPage },
    ]
  },
  { path: 'menu-section/:id', component: MenuSectionPage },
  { path: 'products', component: ProductsComponent },
  { path: 'menu-item/:id', component: MenuItemPage },
  { path: 'menu-item', component: MenuItemPage },
  { path: 'info', component: HotelInfoPage },
  { path: 'requests', component: RequestsComponent },
  { path: 'reserve-list', component: ReservationListComponent },
  { path: 'live-support', component: LiveSupportComponent },
  { path: 'profiles', component: ProfilesComponent },
  { path: 'marketing', component: MarketingComponent },
  { path: 'profile/:id', component: EditProfileComponent },
];

@NgModule({
  declarations: [
    HomePage,
    WelcomePage,
    MenuSectionPage,
    MenuItemPage,
    HotelInfoPage,
    RequestsComponent,
    ProfilesComponent,
    EditProfileComponent,
    MarketingComponent,
    ProductsComponent,
    CategoryFinderPipe,
    PriceFinderPipe,
    UpdateFinderPipe,
    DeliveryComponent,
    PaymentTypesComponent,
    OrderTypesComponent,
    ProductPromotionComponent,
    RequestComponent,
    RedeemPopupComponent,
    PaymentSetupComponent,
    LiveSupportComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    FormsModule,
    MatMenuModule,
    MatButtonModule,
    CoreModule,
    TranslateModule.forChild(),
    AgmCoreModule,
    NgbModule,
    QuillModule,
    PartialsModule,
    DxChartModule,
    DragDropModule,
    DxDataGridModule,
    DxButtonModule,
    MatSelectModule,
    QRCodeModule,
    MatChipsModule,
    MatIconModule,
    PartialsModule,
    MatFormFieldModule,
    MatStepperModule,
    MatTableModule,
    NgxDatatableModule,
    FormsModule,
    DxButtonModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxPopupModule,
    DxScrollViewModule,
    PopupModule,
    CoreModule,
    NgbRatingModule,
    DxChartModule,
    NgbTabsetModule,
    NgbDropdownModule,
    MatInputModule,
    DxLoadPanelModule,
    MatIconModule,
    DxHtmlEditorModule,
    ReactiveFormsModule
  ],
  providers: [
    MenuSectionService,
    CaptionPipe,
    PriceFinderPipe
  ]
})
export class HomeModule {
}
